<style lang="scss">
.getmore-left {
  display: none;
}
@keyframes showInLeft {
  0% {
    opacity: 0;
    transform: translateX(-1rem);
  }
  100% {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes fadeInLeft {
  0% {
    opacity: 1;
    transform: translateX(0);
  }
  100% {
    opacity: 0;
    transform: translateX(-1rem);
  }
}

.buttonRed {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 6rem;

  .getmore-button {
    width: 8rem;
    height: 3rem;
    background-color: #e5004f;
    border-radius: 2rem;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    .getmore-title {
      font-family: "PingFang SC", "Microsoft YaHei";
      color: #fff;
      font-size: 1rem;
      font-weight: normal;
    }
    &:hover {
      // width: 8rem;
      cursor: pointer;
      // transition: all 0.2s;

      // .getmore-left {
      //   animation: showInLeft 1s 1;
      //   display: inline-block;
      //   font-family: "PingFang SC", "Microsoft YaHei";
      //   color: #fff;
      //   font-size: 1.2rem;
      //   margin-left: 1rem;
      // }
    }
  }
}
</style>

<template>
  <div class="buttonRed">
    <div class="getmore-button">
      <div class="getmore-title">
        查看更多<span class="getmore-left">></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "buttonRed",
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
